import * as React from "react";
import Svg, { Path } from "react-native-svg";

function Packets(props) {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <Path
        d="M15.2168 2H4.78321C4.38802 2 4.0299 2.22095 3.8694 2.56379L2 6.55696H18L16.1306 2.56379C15.9701 2.22095 15.612 2 15.2168 2Z"
        stroke="#666666"
        stroke-width="1.3"
        stroke-linejoin="round"
      />
      <Path
        d="M18 16.1024V6.55696H2V16.1024C2 16.6296 2.44772 17.057 3 17.057H17C17.5523 17.057 18 16.6296 18 16.1024Z"
        stroke="#666666"
        stroke-width="1.3"
        stroke-linejoin="round"
      />
      <Path
        d="M12.75 10H7.25C6.55964 10 6 10.4477 6 11V11C6 11.5523 6.55964 12 7.25 12H12.75C13.4404 12 14 11.5523 14 11V11C14 10.4477 13.4404 10 12.75 10Z"
        stroke="#666666"
        stroke-width="1.3"
      />
    </Svg>
  );
}

export default Packets;
